module.exports = __webpack_public_path__ + "media/loans/college_ave-3740c304.svg";